package net.sparklypower.website.frontend

fun main() {
    val m = SparklyWebsiteFrontend()
    m.start()
}